import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './layout/footer/footer.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PreloaderComponent } from './util/preloader/preloader.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { LoadingService } from './service/loading.service';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ShadowContentComponent } from './layout/shared/shadow-content.component';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    PreloaderComponent,
    FormsModule,
    RouterOutlet,
    FooterComponent,
    CommonModule,
    NgxSpinnerModule,
    NgxLoadingModule,
    NgxExtendedPdfViewerModule,
    ShadowContentComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title: string = '';
  isLoading = true;
  loading = false;
  data: any;
  constructor(private loadingService: LoadingService) {}
  ngOnInit() {
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  }

  ngAfterContentChecked(): void {
    this.loadingService.OnLoading.subscribe((data: boolean) => {
      if (this.loading != data) {
        this.loading = data;
      }
    });
  }
}
